export default class Login {
    constructor(That) {
        this.That = That;
    };

    getUserAccessToken = ($params) => {
        let That = this;
        let getUserAccessToken = this.That.ApiUrl('getUserAccessToken');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(getUserAccessToken, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };

    login = ($params) => {
        let That = this;
        let login = this.That.ApiUrl('login');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(login, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };
    regSendCode = ($params) => {
        let That = this;
        let regSendCode = this.That.ApiUrl('regSendCode');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(regSendCode, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };
    reg = ($params) => {
        let That = this;
        let reg = this.That.ApiUrl('reg');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(reg, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };

    UserBindPhone = ($params) => {
        let That = this;
        let UserBindPhone = this.That.ApiUrl('UserBindPhone');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(UserBindPhone, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };

    smsLogin = ($params) => {
        let That = this;
        let UserBindPhone = this.That.ApiUrl('smsLogin');
        return new Promise(function (resolve, reject) {
            That.That.$http.post(UserBindPhone, $params).then(res => {
                res = res.data;
                resolve(res)
            }).catch(err => {
                reject(err);
            })
        })
    };

}


// WEBPACK FOOTER //
// ./src/assets/api/Login.js